"use strict";

var _defineProperty = require("/home/runner/work/react-nexys-boilerplate/react-nexys-boilerplate/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/defineProperty");

var _slicedToArray = require("/home/runner/work/react-nexys-boilerplate/react-nexys-boilerplate/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importStar(require("react"));

var utils_1 = require("../../utils");

var renderLoading = function renderLoading(isLoading, Loader) {
  if (isLoading) {
    return react_1.default.createElement(Loader, null);
  }

  return react_1.default.createElement(react_1.default.Fragment, null);
};

var messageDefault = {
  edit: {
    success: 'Page has been updated successfully',
    error: 'error.message'
  }
};

var Form = function Form(outerProps) {
  return function InnerForm(props) {
    var UI = props.UI,
        promise = props.promise,
        onUpdate = props.onUpdate,
        onToggle = props.onToggle,
        _props$message = props.message,
        message = _props$message === void 0 ? messageDefault : _props$message;
    var useSnackbar = outerProps.useSnackbar,
        Loader = outerProps.Loader;

    var _useSnackbar = useSnackbar(),
        enqueueSnackbar = _useSnackbar.enqueueSnackbar;

    var _react_1$useState = react_1.useState(props.data),
        _react_1$useState2 = _slicedToArray(_react_1$useState, 2),
        data = _react_1$useState2[0],
        setData = _react_1$useState2[1];

    var _react_1$useState3 = react_1.useState(props.errors),
        _react_1$useState4 = _slicedToArray(_react_1$useState3, 2),
        errors = _react_1$useState4[0],
        setErrors = _react_1$useState4[1];

    var _react_1$useState5 = react_1.useState(false),
        _react_1$useState6 = _slicedToArray(_react_1$useState5, 2),
        isLoading = _react_1$useState6[0],
        setIsLoading = _react_1$useState6[1];

    react_1.useEffect(function () {
      setData(Object.assign({}, props.data));
    }, [props.data]);
    react_1.useEffect(function () {
      setErrors(props.errors);
    }, [props.errors]);

    if (!data) {
      return react_1.default.createElement(react_1.default.Fragment, null);
    }

    var handleChange = function handleChange(a) {
      return setData(Object.assign(Object.assign({}, data), _defineProperty({}, a.name, a.value)));
    };

    var handleSubmit = function handleSubmit(e) {
      e.preventDefault();
      setIsLoading(true);
      promise(Object.assign(Object.assign({}, data), props.extra), props).then(function (result) {
        setErrors(undefined);
        setIsLoading(false);
        utils_1.confirmMessage(enqueueSnackbar, result.message || message.edit.success, 'success');
        onUpdate && onUpdate(data, result);
        onToggle && onToggle(false, true);
      }, function (errorResult) {
        var perrors = errorResult.errors,
            errorsField = errorResult.errorsField,
            data = errorResult.data;
        var errors = errorsField || data || perrors;
        setErrors(errors);
        setIsLoading(false);
        utils_1.confirmMessage(enqueueSnackbar, errorResult.message || message.edit.error, 'error');
      });
    };

    return react_1.default.createElement(react_1.default.Fragment, null, react_1.default.createElement(UI, {
      onSubmit: handleSubmit,
      onChange: handleChange,
      onCancel: onToggle,
      data: data,
      errors: errors,
      options: props.options
    }), renderLoading(isLoading, Loader));
  };
};

exports.default = Form;